import _Promise from "babel-runtime/core-js/promise";
export default {
  getImgUrlBase64Async: function getImgUrlBase64Async(fileObj) {
    return new _Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(fileObj);
      reader.onload = function (e) {
        resolve(e.target.result);
      };
    });
  },
  imageZip: function imageZip(opt) {
    var _this = this;
    var img = new Image();
    img.src = opt.src;
    var size = opt.size || 1024 * 1024;
    img.onload = function () {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var width = img.width * 0.9;
      var height = img.height * 0.9;
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      var url = canvas.toDataURL(opt.type || "image/jpeg", 0.5);
      if (url.length > size) {
        _this.imageZip({
          src: url,
          type: opt.type,
          size: size,
          callback: opt.callback
        });
        return;
      }
      opt.callback && opt.callback(url);
    };
  },
  imageZipAsync: function imageZipAsync(opt) {
    var _this = this;
    return new _Promise(function (resolve, reject) {
      var img = new Image();
      img.src = opt.src;
      var size = opt.size || 1024 * 1024;
      var n = 0.9;
      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var width = img.width * n;
        var height = img.height * n;
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        var url = canvas.toDataURL(opt.type || "image/jpeg", 0.5);
        if (url.length > size) {
          for (var i = 1; i < 100; i++) {
            canvas.width = width * (n - i * 0.1);
            canvas.height = height * (n - i * 0.1);
            ctx.drawImage(img, 0, 0, width * (n - i * 0.1), height * (n - i * 0.1));

            url = canvas.toDataURL(opt.type || "image/jpeg", 0.5);
            if (url.length < size) {
              break;
            }
          }
        }
        resolve({ errorCode: 0, url: url });
      };
      img.onerror = function () {
        reject({ errorCode: 1, msg: "图片加载失败！" });
      };
    });
  },
  getBase64URL: function getBase64URL(pic) {
    var blob = this.base64ImgtoFile(pic);
    var blobUrl = window.URL.createObjectURL(blob);

    return blobUrl;
  },
  base64ImgtoFile: function base64ImgtoFile(dataurl) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "file";

    var arr = dataurl.split(",");

    var mime = arr[0].match(/:(.*?);/)[1];
    var suffix = mime.split("/")[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename + "." + suffix, {
      type: mime
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/imageNode/child/imgTools.js
// module id = 129
// module chunks = 2